import getCompatibleWeakMap from 'src/internal/shared/apollo/getCompatibleWeakMap';

import type {InMemoryCache} from '@apollo/client';

const CompatibleMap = getCompatibleWeakMap();

let sharedApolloCaches: WeakMap<Symbol, InMemoryCache> | null = null;

export function getApolloSharedCaches() {
  if (sharedApolloCaches) {
    return sharedApolloCaches;
  }

  sharedApolloCaches = new CompatibleMap<Symbol, InMemoryCache>();
  return sharedApolloCaches;
}
